"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryStringVal = exports.getQuery = exports.default = void 0;
var _function = require("../type-checks/function");
var _react = require("react");
const getQuery = () => {
    return typeof window?.location?.search === "string" ? new URLSearchParams(window.location.search) : new URLSearchParams();
  },
  getQueryStringVal = key => {
    return getQuery().get(key);
  };

/**
 * Hook to retrieve a query parameter value
 *
 * @name useQueryParam
 * @param {string} key Query key label
 * @param {string} defaultValue Default value for key
 * @returns {array} Hooks array of value and setter for changing URL
 */
exports.getQueryStringVal = getQueryStringVal;
exports.getQuery = getQuery;
const useQueryParam = function (key) {
  let defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  const [query, setQuery] = (0, _react.useState)(getQueryStringVal(key) || defaultValue),
    updateUrl = newValue => {
      setQuery(newValue);
      const query = getQuery();
      if (newValue.trim() !== "") {
        query.set(key, newValue);
      } else {
        query.delete(key);
      }
      if ((0, _function.isFunction)(window?.history?.pushState)) {
        const {
          protocol,
          pathname,
          host
        } = window.location;
        const newUrl = `${protocol}//${host}${pathname}?${query.toString()}`;
        window.history.pushState({}, "", newUrl);
      }
    };
  return [query, updateUrl];
};
var _default = exports.default = useQueryParam;